import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import { ReactComponent as Gestaodainfo } from "../../assets/icons/gestaodainfo.svg";
import { ReactComponent as IconIndustria } from "../../assets/icons/kpisEstruturais/icon-industria.svg";
import { ReactComponent as IconGestao } from "../../assets/icons/kpisEstruturais/icon-gestao.svg";
import { ReactComponent as IconEquipeVendas } from "../../assets/icons/kpisPerformance/icon-kpisperformance.svg";
import { ReactComponent as IconCapacidade } from "../../assets/icons/kpisEstruturais/icon-capacidade.svg";
import { ReactComponent as IconAtiginmentoKPIS } from "../../assets/icons/kpisPerformance/icon-atingimento.svg";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function KpisEstruturaisDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Pontuação");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const [hideText, setHideText] = useState(false);
  const [mesUm, setMesUm] = useState();
  const [mesDois, setMesdois] = useState();
  const [mesTres, setMesTres] = useState();

  const [numberCard1, setNumberCard1] = useState();
  const [numberCard2, setNumberCard2] = useState();
  const [numberCard3, setNumberCard3] = useState();
  const [numberCard4, setNumberCard4] = useState();
  const [numberCard5, setNumberCard5] = useState();

  const handleChange = (event) => {
    app.field("Nm_Visu").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  const fetchTransformObjectValueInText = useCallback(
    async (objectId, index) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          index === 1 && setMesUm(value);
          index === 2 && setMesdois(value);
          index === 3 && setMesTres(value);
        });
      }
    },
    [app, setMesUm, setMesdois, setMesTres]
  );

  const getNumberforBigNumbers = useCallback(
    async (objectId, index) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          index === 1 && setNumberCard1(value);
          index === 2 && setNumberCard2(value);
          index === 3 && setNumberCard3(value);
          index === 4 && setNumberCard4(value);
          index === 5 && setNumberCard5(value);
        });
      }
    },
    [app, setMesUm, setMesdois, setMesTres]
  );

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Nm_Visu")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
      fetchTransformObjectValueInText("RdUkJR", 1);
      fetchTransformObjectValueInText("aJSNBqB", 2);
      fetchTransformObjectValueInText("JhnnTf", 3);
      getNumberforBigNumbers("nJTZJD", 1);
      getNumberforBigNumbers("pFHjFg", 2);
      getNumberforBigNumbers("ccUpXD", 3);
      getNumberforBigNumbers("FCRYn", 4);
      getNumberforBigNumbers("TJYq", 5);
    }
  }, [app, selections]);

  function numerosMeses() {
    const nomesDosMeses = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];

    return {
      primeiroMes: nomesDosMeses[mesUm - 1],
      segundoMes: nomesDosMeses[mesDois - 1],
      terceiroMes: nomesDosMeses[mesTres - 1],
    };
  }
  const meses = numerosMeses();

  return (
    <div className="app estruturais">
      <div className="appContent">
        <div className="container-titles">
          <h3
            style={{
              margin: "16px 16px 7.5px 24px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <span>KPIs Estruturais</span>
            <Tooltip
              title="KPIs são instrumentos essenciais na gestão empresarial, fornecendo
              métricas objetivas e mensuráveis para avaliar o progresso em
              direção aos objetivos organizacionais."
              TransitionProps={{ timeout: 600 }}
              arrow
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -14],
                      },
                    },
                  ],
                },
              }}
              sx={{
                "& .MuiTooltip-tooltip": {
                  color: "red", // Altere para a cor desejada
                },
              }}
            >
              <Gestaodainfo />
            </Tooltip>
          </h3>
        </div>

        <FormControl className="container-form-control">
          <RadioGroup
            defaultValue="Pontuação"
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "27px" }}
          >
            <FormControlLabel
              value="Pontuação"
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Pontuação"
            />

            <FormControlLabel
              value="Pontualidade de envio"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Gestão de Dados"
            />
          </RadioGroup>
        </FormControl>

        {selectedValue === "Pontuação" ? (
          <LayoutCardsWrapper style={{ height: "100%" }}>
            <LayoutCardWrapper>
              <div className="group-cards">
                <>
                  <span style={{ fontWeight: "bold" }}>Pontuação</span>
                  <div className="adm-cards">
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Indústria de Destilados",
                      }}
                      className={"container-card-item"}
                    >
                      <div className="informativo-kpis informativo-one">
                        <Tooltip
                          title="Não trabalhar com outra indústria no segmento de GIN, VODKA e WHISKY."
                          TransitionProps={{ timeout: 600 }}
                          arrow
                          slotProps={{
                            popper: {
                              modifiers: [
                                {
                                  name: "offset",
                                  options: {
                                    offset: [0, -14],
                                  },
                                },
                              ],
                            },
                          }}
                        >
                          <Gestaodainfo />
                        </Tooltip>
                      </div>
                      <div className="container-object-and-icon">
                        <p className={"container-card-item-object"}>
                          {numberCard1}
                        </p>

                        <IconIndustria />
                      </div>
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Gestão de Dados",
                      }}
                      className={"container-card-item"}
                    >
                      <div className="informativo-kpis informativo-two">
                        <Tooltip
                          title="Compartilhamento AUTOMÁTICO de dados de Sell Out e estoque via MTRIX com frequência diária (90%)."
                          TransitionProps={{ timeout: 600 }}
                          arrow
                          slotProps={{
                            popper: {
                              modifiers: [
                                {
                                  name: "offset",
                                  options: {
                                    offset: [0, -14],
                                  },
                                },
                              ],
                            },
                          }}
                        >
                          <Gestaodainfo />
                        </Tooltip>
                      </div>

                      <div className="container-object-and-icon">
                        <p className={"container-card-item-object"}>
                          {numberCard2}
                        </p>

                        <IconGestao />
                      </div>
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Equipe de Vendas",
                      }}
                      className={"container-card-item"}
                    >
                      <div className="informativo-kpis  informativo-three">
                        <Tooltip
                          title="Ter pessoas de vendas direcionadas no canal foco de distribuição."
                          TransitionProps={{ timeout: 600 }}
                          arrow
                          slotProps={{
                            popper: {
                              modifiers: [
                                {
                                  name: "offset",
                                  options: {
                                    offset: [0, -14],
                                  },
                                },
                              ],
                            },
                          }}
                        >
                          <Gestaodainfo />
                        </Tooltip>
                      </div>
                      <div className="container-object-and-icon">
                        <p className={"container-card-item-object"}>
                          {numberCard3}
                        </p>

                        <IconEquipeVendas />
                      </div>
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Capacidade de Execução",
                      }}
                      className={"container-card-item"}
                    >
                      <div className="informativo-kpis  informativo-foor">
                        <Tooltip
                          title="Ter pessoas direcionadas para execução no canal foco de distribuição (Merchandising, consultores de on trade, consultores de eventos)."
                          TransitionProps={{ timeout: 600 }}
                          arrow
                          slotProps={{
                            popper: {
                              modifiers: [
                                {
                                  name: "offset",
                                  options: {
                                    offset: [0, -14],
                                  },
                                },
                              ],
                            },
                          }}
                        >
                          <Gestaodainfo />
                        </Tooltip>
                      </div>
                      <div className="container-object-and-icon">
                        <p className={"container-card-item-object"}>
                          {numberCard4}
                        </p>

                        <IconCapacidade />
                      </div>
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "% Atingimento KPI Estruturais",
                      }}
                      className="kpis-atingimento container-card-item"
                    >
                      <div className="container-object-and-icon">
                        <p className={"container-card-item-object"}>
                          {numberCard5}
                        </p>
                        <IconAtiginmentoKPIS />
                      </div>
                    </Card>
                  </div>

                  <div style={{ height: hideText ? "76%" : "67%" }}>
                    <Card
                      app={app}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      exportContainer
                      exportTable
                      exportTableId="jJYwe"
                    >
                      <NativeObject
                        app={app}
                        key="jJYwe"
                        reference={{ id: "jJYwe" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>
                  </div>
                </>
              </div>
            </LayoutCardWrapper>
          </LayoutCardsWrapper>
        ) : null}

        {selectedValue === "Pontualidade de envio" ? (
          <LayoutCardsWrapper style={{ height: "150%" }}>
            <LayoutCardWrapper>
              <div className="group-cards">
                <>
                  <span style={{ fontWeight: "bold" }}>Legenda</span>
                  <span>
                    🟢 Enviou 🟡 Não enviou mas justificou 🔴 Não enviou e não
                    justificou ⚪️ Não fatura neste dia
                  </span>

                  <Card
                    app={app}
                    header={{
                      hardTitle: "Resumo Envio - Pontualidade",
                    }}
                    style={{
                      width: "100%",
                      height: "50%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="bApENJ"
                    className="container-pontualidade-resumo"
                  >
                    <NativeObject
                      app={app}
                      key="bApENJ"
                      reference={{ id: "bApENJ" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: `Envio de Informações do mês de ${meses.primeiroMes}`,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="HfJwxfu"
                  >
                    <NativeObject
                      app={app}
                      key="bzBJJR"
                      reference={{ id: "bzBJJR" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: `Envio de Informações do mês de ${meses.segundoMes}`,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="zPrcw"
                  >
                    <NativeObject
                      app={app}
                      key="sPbPbCH"
                      reference={{ id: "sPbPbCH" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: `Envio de Informações do mês de ${meses.terceiroMes}`,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="RgCDzB"
                  >
                    <NativeObject
                      app={app}
                      key="vCPYy"
                      reference={{ id: "vCPYy" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>
                </>
              </div>
            </LayoutCardWrapper>
          </LayoutCardsWrapper>
        ) : null}
      </div>
    </div>
  );
}

KpisEstruturaisDesktop.defaultProps = {
  app: null,
  config: {},
};

KpisEstruturaisDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default KpisEstruturaisDesktop;
